/**
 * Wishlist system — stores saved products in localStorage (per browser/device).
 * Works with snippets/wishlist-button.liquid and sections/wishlist-page.liquid.
 */
(function () {
  var STORAGE_KEY = 'theme:wishlist';

  function readWishlist() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      var parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function writeWishlist(items) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (e) {
      /* localStorage unavailable (private mode, quota, etc.) — fail silently */
    }
  }

  function isSaved(id) {
    return readWishlist().some(function (item) {
      return String(item.id) === String(id);
    });
  }

  function addItem(data) {
    var items = readWishlist();
    if (items.some(function (item) { return String(item.id) === String(data.id); })) {
      return items;
    }
    items.push(data);
    writeWishlist(items);
    return items;
  }

  function removeItem(id) {
    var items = readWishlist().filter(function (item) {
      return String(item.id) !== String(id);
    });
    writeWishlist(items);
    return items;
  }

  function toggleItem(data) {
    if (isSaved(data.id)) {
      removeItem(data.id);
      return false;
    }
    addItem(data);
    return true;
  }

  function updateButtonState(button) {
    var id = button.dataset.productId;
    var saved = isSaved(id);
    button.setAttribute('aria-pressed', saved ? 'true' : 'false');
    button.setAttribute(
      'aria-label',
      saved
        ? (window.wishlistStrings && window.wishlistStrings.remove) || 'Remove from wishlist'
        : (window.wishlistStrings && window.wishlistStrings.add) || 'Add to wishlist'
    );
  }

  function updateAllButtons() {
    document.querySelectorAll('[data-wishlist-toggle]').forEach(updateButtonState);
  }

  function updateCounters() {
    var count = readWishlist().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? '' : 'none';
    });
  }

  function refreshUI() {
    updateAllButtons();
    updateCounters();
  }

  function handleToggleClick(event) {
    var button = event.target.closest('[data-wishlist-toggle]');
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();

    var data = {
      id: button.dataset.productId,
      handle: button.dataset.productHandle,
      title: button.dataset.productTitle,
      price: button.dataset.productPrice,
      image: button.dataset.productImage,
      url: button.dataset.productUrl
    };

    var nowSaved = toggleItem(data);
    document
      .querySelectorAll('[data-wishlist-toggle][data-product-id="' + data.id + '"]')
      .forEach(updateButtonState);
    updateCounters();

    document.dispatchEvent(
      new CustomEvent('wishlist:updated', { detail: { id: data.id, saved: nowSaved } })
    );
  }

  document.addEventListener('click', handleToggleClick);
  document.addEventListener('DOMContentLoaded', refreshUI);
  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    refreshUI();
  }

  window.themeWishlist = {
    getAll: readWishlist,
    remove: function (id) {
      removeItem(id);
      refreshUI();
      document.dispatchEvent(
        new CustomEvent('wishlist:updated', { detail: { id: id, saved: false } })
      );
    },
    isSaved: isSaved,
    refreshUI: refreshUI
  };
})();
